import { builtIn, override } from "./rules.js";
import { baseRules } from "./base.js";

const ALERTS = { Note: "info", Tip: "success", Important: "primary", Warning: "warning", Caution: "danger" };

export const bootstrap = builtIn({
  id: "bootstrap",
  name: "Bootstrap 5",
  basedOn: "bootstrap",
  description: "Bootstrap 5 markup: display headings, lead text, alerts, badges, figure quotes and styled tables.",
  css: ["vendor/bootstrap.min.css"],
  exportCss: ["https://cdn.jsdelivr.net/npm/bootstrap@5.3.8/dist/css/bootstrap.min.css"],
  exportWrapper: "div.container.py-4",
  rules: override(baseRules, {
    "p|Title": { html: "h1.display-5:fresh" },
    "p|Subtitle": { html: "p.lead:fresh" },
    "p|Lead": { html: "p.lead:fresh" },
    "p|Quote": { html: "figure > blockquote.blockquote > p:fresh" },
    "p|Quote Attribution": { html: "figure > figcaption.blockquote-footer:fresh" },
    "p|Intense Quote": { html: "blockquote.blockquote.border-start.border-4.ps-3 > p:fresh" },
    "p|Caption": { html: "p.figure-caption:fresh" },
    ...Object.fromEntries(Object.entries(ALERTS).map(([name, kind]) => [`p|${name}`, { html: `div.alert.alert-${kind} > p:fresh` }])),
    "r|Badge": { html: "span.badge.text-bg-secondary" },
    "table|Grid Table*": { html: "table.table.table-bordered" },
    "table|List Table*": { html: "table.table.table-striped" },
    "table|": { html: "table.table" },
  }),
});
